export var COVER_TYPE_COLOR = 'color';
export var COVER_TYPE_IMAGE = 'image';
export var COVER_TYPE_NONE = 'none';
